/**
 * Arma el PDF de un manifiesto con los pedidos en estado Activo.
 */
import toast from 'react-hot-toast'
import { generarPDFManifiesto } from '../../components/pdf-templates/ManifiestoPDF'
import { MANIFIESTOS_CARRIERS, carrierLabel } from '../../config/manifiestos/manifiestosCarriersConfig'
import { getManifiesto, getPedidoDetalle } from '../../services/manifiestos/manifiestosService'
import { MANIFIESTO_LINEA_ACTIVA, type ManifiestoPedidoLinea } from '../../types/manifiestos'
import { mapOrdersToManifiestoRows } from './manifiestoMapper'

export async function imprimirManifiestoPdf(
  id: number,
  transportadora: string
): Promise<boolean> {
  const full = await getManifiesto(id)
  const activas = (full.pedidos || []).filter(
    (linea) => String(linea.estado || MANIFIESTO_LINEA_ACTIVA) === MANIFIESTO_LINEA_ACTIVA
  )
  if (activas.length === 0) {
    toast.error('No hay pedidos activos para imprimir', { position: 'top-center' })
    return false
  }

  const detalles = await Promise.all(activas.map((linea) => detalleDeLinea(linea)))
  const { rows } = mapOrdersToManifiestoRows(detalles)
  rows.forEach((row) => {
    const source = detalles.find((item) => Number((item as { id?: number }).id) === row.orderId) as {
      _numero?: string | number
      _paq?: number
      _und?: number
      guia?: string
    } | undefined
    if (!source) return
    row.numeroVisible = String(source._numero ?? row.orderId)
    if (source.guia) row.guia = String(source.guia)
    const unidades = Number(source._und)
    const paquetes = Number(source._paq)
    if (Number.isFinite(unidades) && unidades > 0) row.und = unidades
    else if (Number.isFinite(paquetes) && paquetes > 0) row.und = paquetes
    if (Number.isFinite(paquetes) && paquetes > 0) {
      const cajas = `${paquetes} CAJ`
      row.contenido = row.contenido ? `${cajas} · ${row.contenido}` : cajas
    }
  })

  const option = MANIFIESTOS_CARRIERS.find((item) => item.transportadora === transportadora)
  await generarPDFManifiesto(
    option || { id: 'manifiesto', label: carrierLabel(transportadora), transportadora },
    rows
  )
  return true
}

async function detalleDeLinea(linea: ManifiestoPedidoLinea): Promise<unknown> {
  const detalle = await getPedidoDetalle(linea.id_pedido)
  const base = detalle && typeof detalle === 'object' ? (detalle as Record<string, unknown>) : {}
  return {
    ...base,
    id: linea.id_pedido,
    guia: linea.guia || base.guia || '—',
    _numero: linea.numero_pedido,
    _paq: linea.paquetes_verificados,
    _und: linea.unidades_empaque,
  }
}
